export const TAGS_SWATCHES = [
  ['#FF0000', '#AA0000', '#550000'],
  ['#FFFF00', '#AAAA00', '#555500'],
  ['#00FF00', '#00AA00', '#005500'],
  ['#00FFFF', '#00AAAA', '#005555'],
  ['#0000FF', '#0000AA', '#000055'],
];

export default {
  tags_swatches: TAGS_SWATCHES,
  props: {
    tags_inital: {
      type: Array,
      required: false,
      default: () => [],
    }
  },
  data: () => ({
    tags_combobox_model: [],
    tags_search: null,
    tags_edit_id: -1,
    tags: [
        { header: 'Selecione uma tag, ou crie uma' },
    ],
    tags_text_before_edit: null,
    tags_color_dialog: null,
  }),
  mounted() {
    this.tags_combobox_model = this.tags_inital;
  },
  watch: {
    tags_combobox_model(val, prev) {
      // We watch for changes in `this.tags_combobox_model` and attach a callback
      // that will cause another change in the same property. In order to prevent
      // an infinite loop, if there is no change in length, we return.
      if (val.length === prev.length) return;

      this.tags_combobox_model = val.map(v => {
        if (typeof v == "string") {
          const new_tag = {
            text: v,
            color: "green",
            id: val.length,
          };
          this.tags.push(new_tag);
          return new_tag;
        } else {
          return v;
        }
      });
    },
  },
  computed: {
    tags_is_editing() {
      return this.tags_edit_id >= 0;
    },
  },
  methods: {
    print_retr(any) {
      console.log(any)
      return any;
    },
    tag_edit(tag) {
      // If it is already editing, reject current edit.
      if (this.tags_edit_id > 0)
        this.tag_edit_reject();

      this.tags_text_before_edit = tag.text;
      this.tags_edit_id = tag.id;
    },
    tag_edit_accept() {
      this.tags_edit_id = -1;
    },
    tag_edit_reject() {
      const tag = this.tags.find(tag => tag.id == this.tags_edit_id);

      if (!tag)
        console.error("Tried to reject edit on a tag that wasn't found.");
      else if (!this.tags_text_before_edit)
        console.error("Tried to reject an edit, but no before edit text was found.");
      else
        tag.text = this.tags_text_before_edit;

      this.tags_edit_id = -1;
    },
    tags_filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = val => val != null ? val : '';

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return text.toString()
        .toLowerCase()
        .indexOf(query.toString().toLowerCase()) > -1;
    },
    tags_add(text) {
      const new_tag = {
        text,
        color: "green",
        id: this.tags_combobox_model.length,
      };
      this.tags_combobox_model.push(new_tag);
      this.tags.push(new_tag);
      this.tags_search = "";
    },
    tags_get() {
      // Copies every tag and changes some things to the more appropriate format.
      return this.tags_combobox_model.map(tag => ({
        name:  tag.text,
        color: tag.color,
        // The value stores the id created by the database.
        id:    tag.value || null,
      }));
    }
  },
};